import dayjs from "dayjs";
import { ChartLegend, ChartToolTip } from "./styles";
import { PlayerDetailType } from "../../../../types/playerDetail";
const { minBy, maxBy } = require('lodash');

const calculatePosition = (input: number) => {
  const numberOfDigits = Math.floor(Math.log10(Math.abs(input))) + 1;
  switch (numberOfDigits) {
    case 0:
    case 1:
      return ['35', '24'];
    case 2:
      return ['40', '26'];
    case 3:
      return ['45', '28'];
    case 4:
      return ['50', '30'];
    default:
      return ['0', '0'];
  }
}

export const SquareDot = (props: any) => {
  const { cx, cy } = props;
  return (
    <rect x={cx - 4} y={cy - 4} width={8} height={8} fill="#bfbfbf" />
  );
};

export const SelectionHandicap = (props: any) => {
  const { viewBox, selectionHandicap } = props;
  return (
    <g transform={`translate(${viewBox.x}, ${viewBox.y})`}>
      <rect
        x="6"
        y="-32"
        width={calculatePosition(selectionHandicap)[0]}
        height="30"
        fill="#1b3d8c"
        rx="4"
      />
      <text x={calculatePosition(selectionHandicap)[1]} y="-16" textAnchor="middle" alignmentBaseline="middle" fill="white">
        {selectionHandicap.toFixed(1)}
      </text>
    </g>
  )
};

export const CustomizedXAxisTick = (props: any) => {
  const { x, y, payload } = props;
  const splitValues = payload.value.split(',');
  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={12} textAnchor="middle" fill="black" fontSize="12px" fontWeight="bold">
        {splitValues[0]}
      </text>
      <text x={0} y={5} dy={24} textAnchor="middle" fill="black" fontSize="12px" fontWeight="bold">
        {splitValues[1].toUpperCase()}
      </text>
    </g>
  );
};

export const CustomTooltip = (props: any) => {
  const { active, payload, showPrevLines, selectionHandicap } = props;
  if (active && payload && payload.length >= 1) {
    return (
      <ChartToolTip isGreen={payload[0].payload.value >= (showPrevLines ? payload[0].payload.handicap : selectionHandicap)}>
        {
          showPrevLines && <div>+{payload[0].payload.handicap}</div>
        }
        <div><span>{payload[0].payload.value}</span></div>
        <div>{payload[0].payload.opponentCode} ({payload[0].payload.side.charAt(0).toUpperCase()})</div>
        <div>{dayjs(payload[0].payload.date).format('MM/DD')}</div>
      </ChartToolTip>
    );
  }

  return null;
};

export const renderLegend = (chartData: PlayerDetailType[]) => {
  const minDate = minBy(chartData, 'date');
  const maxDate = maxBy(chartData, 'date');
  return (
    <ChartLegend>Games &#8226; {dayjs(minDate.date).format('MM/DD')} - {dayjs(maxDate.date).format('MM/DD')}</ChartLegend>
  )
}

export const getFillColor = (showPrevLines: boolean, selectionHandicap: number, value: number, handicap: number) => {
  const threshold = showPrevLines ? handicap : selectionHandicap;
  return value > threshold ? '#73d13d' : '#ff4d4f';
};